module.exports = __webpack_public_path__ + "static/media/tweeter.91c9d82c.svg";